// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/x-office-document.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../img/x-office-spreadsheet.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../img/x-office-presentation.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
.icon-filetype-document{
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
}

.icon-filetype-spreadsheet{
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.icon-filetype-presentation{
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
`, "",{"version":3,"sources":["webpack://./src/css/icons.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;CACC;AACD;;AAEA;CACC,yDAA2D;AAC5D;;AAEA;CACC,yDAA4D;AAC7D","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n.icon-filetype-document{\n\tbackground-image: url('../../img/x-office-document.svg')\n}\n\n.icon-filetype-spreadsheet{\n\tbackground-image: url('../../img/x-office-spreadsheet.svg');\n}\n\n.icon-filetype-presentation{\n\tbackground-image: url('../../img/x-office-presentation.svg');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
